import { TextField } from '@mui/material';
import { useCaseFieldData, useCaseFieldDispatch } from '../../hooks/useCaseField';
import type { FieldMode } from '../../hooks/useCaseField';
import type { MedNecCaseView } from '../../../../services/MedNecService/types/medNecTypes';

interface CaseTextFieldProps {
  mode: FieldMode;
  label: string;
  getValue: (data: MedNecCaseView) => string;
  getUpdate: (value: string, data: MedNecCaseView) => Partial<MedNecCaseView>;
  required?: boolean;
  error?: string;
  type?: string;
  multiline?: boolean;
  minRows?: number;
  maxRows?: number;
  inputProps?: Record<string, unknown>;
  shrinkLabel?: boolean;
  fullWidth?: boolean;
}

const CaseTextField: React.FC<CaseTextFieldProps> = ({
  mode, label, getValue, getUpdate,
  required, error, type, multiline, minRows, maxRows,
  inputProps, shrinkLabel, fullWidth,
}) => {
  const data = useCaseFieldData(mode);
  const { dispatchUpdate, readOnly } = useCaseFieldDispatch(mode);

  return (
    <TextField
      label={label}
      required={required}
      size="small"
      type={type}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRows}
      fullWidth={fullWidth}
      disabled={readOnly}
      value={getValue(data)}
      onChange={e => dispatchUpdate(getUpdate(e.target.value, data))}
      error={!!error}
      helperText={error}
      inputProps={inputProps}
      slotProps={shrinkLabel ? { inputLabel: { shrink: true } } : undefined}
    />
  );
};

export default CaseTextField;
